export const redirects: Record<string, string> = {
  '/signup': '/sign-up',
  '/sign-in': '/login',
  '/signin': '/login',
  '/log-in': '/login',
}
